// extracted by mini-css-extract-plugin
export default {"wrapper":"vt-z","viewport":"wt-z","container":"xt-z","slide":"yt-z"};